import lrCompanySelect from './_src/lrCompanySelect.vue'

lrCompanySelect.install = function(Vue) {
  Vue.component(lrCompanySelect.name, lrCompanySelect)
}

export default lrCompanySelect